import script from "./InvestmentTransactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestmentTransactions.vue?vue&type=script&setup=true&lang=ts"

import "./InvestmentTransactions.vue?vue&type=style&index=0&id=72326796&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72326796"]])

export default __exports__